document.addEventListener('DOMContentLoaded', () => {
    // Select all video elements with the class 'inline-control' or wp-core video blocks with autoplay, loop, and muted attributes
    const videos = document.querySelectorAll('video.inline-control, .wp-block-video video[autoplay][loop][muted]');

    videos.forEach(video => {
        // Create control container
        const controls = document.createElement('div');
        controls.className = 'video-controls';

        // Play/Pause button
        const playPauseBtn = document.createElement('button');
        playPauseBtn.className = 'play-pause';
        playPauseBtn.textContent = 'Play';
        controls.appendChild(playPauseBtn);

        // Append controls to the video container
        video.parentNode.insertBefore(controls, video.nextSibling);

        // Event listeners for buttons and slider
        playPauseBtn.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                playPauseBtn.textContent = 'Pause';
            } else {
                video.pause();
                playPauseBtn.textContent = 'Play';
            }
        });

        // Update buttons based on video state
        video.addEventListener('play', () => {
            playPauseBtn.textContent = 'Pause';
            playPauseBtn.classList.add('playing');
            playPauseBtn.classList.remove('paused');
        });

        video.addEventListener('pause', () => {
            playPauseBtn.textContent = 'Play';
            playPauseBtn.classList.remove('playing');
            playPauseBtn.classList.add('paused');
        });
    });
});
